<template>
  <div v-if="!rows.length" class="an-empty">
    <i class="fa fa-table"></i>
    <span>За период нет строк</span>
  </div>
  <div v-else class="an-table-wrap">
    <table class="an-table">
      <thead>
      <tr>
        <th v-for="(col, i) in columns" :key="col.id" :class="{ 'text-right': i > 0 }">{{ col.label }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(row, r) in rows" :key="r">
        <td v-for="(cell, i) in row" :key="columns[i] ? columns[i].id : i" :class="{ 'text-right': i > 0 }">
          {{ cell }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import {formatValue} from "@/common/viewFormat";

export default {
  name: "ViewTable",
  props: {
    table: {type: Object, required: true},
  },
  computed: {
    columns() {
      return this.table.columns || []
    },
    rows() {
      return (this.table.rows || []).map(row => row.map((cell, i) => {
        if (typeof cell !== 'number') return cell
        return formatValue(cell, (this.columns[i] || {}).unit)
      }))
    },
  },
}
</script>
